module.exports = __webpack_public_path__ + "media/images/covers/Roadmap-To-Oxbridge-Cover-c11b70adb806848c9ed972567b3c33e2.png";